/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Ledger_Col_NoteInputs */

const vi_customer_debt_ledger_col_note = /** @type {(inputs: Customer_Debt_Ledger_Col_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú`)
};

/**

* @param {Customer_Debt_Ledger_Col_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_ledger_col_note = /** @type {((inputs?: Customer_Debt_Ledger_Col_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Ledger_Col_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_ledger_col_note(inputs)
});